import { TooltipProps } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

import { Placement } from '@popperjs/core';

import { Tooltip } from './TooltipWithQuestionMark.styled';

interface TooltipWithQuestionMarkProps
    extends Omit<TooltipProps, 'placement' | 'children'> {
    placement?: Placement;
}

export const TooltipWithQuestionMark = ({
    placement = 'top',
    ...rest
}: TooltipWithQuestionMarkProps) => {
    return (
        <Tooltip distance={10} placement={placement} width={324} {...rest}>
            <IconManager
                icon="SvgHelp24"
                size={24}
                themeColors={{
                    default: {
                        'color-1': 'input.disabledPlaceholder',
                        'color-2': 'tooltip.text',
                    },
                }}
            />
        </Tooltip>
    );
};
